<template>
  <div>
    <v-layout>
      <v-flex xs5 sm5>
        <v-btn :color="showFilter? 'green' : 'black'" :outline="showFilter ? false : true" @click="filterSwitched">
          Filtry
        </v-btn>
        <v-btn
          fab small
          v-if="showFilter"
          @click="range++"
          >
          <v-icon small>add</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <div v-if="show">
      <div>
        <slot></slot>
      </div>
      <div :key="i" v-for="i in range">
        <v-layout >
          <v-flex xs5 sm3 >
            <v-select
              @change="changeHandler"
              :items="fields"
              item-text="name"
              item-value="value"
              v-model="choosenFields[i]"
              :label="`${$t('form.inputs.select_field')}`"
            ></v-select>
          </v-flex>

          <v-flex v-if="isRadioField(choosenFields[i])" sm3 xs5>
            <v-select
                v-model="search[i]"
                :items="getRadioValues(choosenFields[i])"
                item-text="value"
                item-value="key"
                label="Szukaj"
                prepend-icon="search"
                required
                style="margin-left:2rem;"
                @change="changeHandler"
            ></v-select>
          </v-flex>

          <v-flex v-else sm3 xs5>
            <v-text-field @change="changeHandler"
              style="margin-left:2rem;"
              v-model="search[i]"
              prepend-icon="search"
              label="Szukaj"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs2 sm2>
          <v-btn
          v-if="i!=1"
          style="margin-left:2rem;"
            fab small block
            @click="removeFiltr(i)">
            <v-icon small>remove</v-icon>
          </v-btn>
        </v-flex>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
import QueryConditionBuilder from '@/plugins/QueryConditionBuilder'
import InputHelper from '@/plugins/InputHelper'

export default {
  components: {},
  data() {
    return {
      QueryConditionBuilder: QueryConditionBuilder,
      search: [],
      showFilter: false,
      range: 1,
      choosenFields: [],
      lastCondition: "{}",
      baseFieldsFilter: [
        {name: "Imie", value: "name"},
        {name: "Nazwisko", value: "surname"}
      ]
    }
  },
  computed: {
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
    fields(){
      let fields =  this.$store.state.forms.schema.fields
          .filter(this.isEditableField)
          .map(field => {
            return {name: field.name, value: field.order}
          })
      return this.baseFieldsFilter.concat(fields)
    },
    show(){
      return this.showFilter
    }
  },
  methods:{
    getField(order) {
      if (!order) {
        return false
      }

      return this.$store.state.forms.schema.fields.find(el => el.order == order)
    },
    getRadioValues(order) {
      let field = this.getField(order)
      return field.values.map(v => ({key: String(v.key), value: v.value}))
    },
    isRadioField(order) {
      let field = this.getField(order)
      return field ? field.type == 'radio' : false
    },
    removeFiltr(index){
      this.choosenFields.splice(index,1);
      this.search.splice(index,1)
      this.range--;
      this.$emit('change-condition',this.buildCondition())
    },
    clearURLQueryParams() {
      window.history.pushState({}, document.title, window.location.pathname)
    },
    buildCondition() {
      let queryBuilder = new this.QueryConditionBuilder()
      let field
      this.clearURLQueryParams()
      const searchURL = new URL(window.location)

      this.choosenFields.forEach((paramName, i) => {
        if (!this.search[i]) {
          return
        }

        if (this.QueryConditionBuilder.baseFields().includes(paramName)) {
          queryBuilder.appendBaseFieldCondition(paramName, this.search[i])
          searchURL.searchParams.set(paramName, this.search[i])
        }else {
          field = this.$store.state.forms.schema.fields.find(function (el) {
            return el.order == paramName
          })

          searchURL.searchParams.set(queryBuilder.buildParamName(field), this.search[i])
          queryBuilder.appendCondition(field, this.search[i])
        }
      })

      window.history.pushState({}, '', searchURL)
      return queryBuilder.getConditions()
    },
    changeHandler() {
      let condition = this.buildCondition()
      let conditionLength = Object.keys(condition).length
      let strCondition = JSON.stringify(condition)

      if ((conditionLength > 0 && strCondition != this.lastCondition) ||
      (conditionLength == 0 && strCondition != this.lastCondition) ){

        this.$emit('change-condition', condition)
        this.lastCondition = strCondition
      }
    },
    filterSwitched() {
      this.showFilter = !this.showFilter
      if (!this.showFilter) {
        this.$emit('change-condition', {})
        this.clearURLQueryParams()
        this.choosenFields = []
        this.search = []
        this.range = 1
      }
    },
    isEditableField(field) {
      return InputHelper.isEditableField(field)
    },
    applyFilterFromUrl() {
      let queryBuilder = new this.QueryConditionBuilder()
      let i = 1

      for (let paramName in this.$route.query) {
        let order = queryBuilder.extractOrder(paramName)

        if (this.QueryConditionBuilder.baseFields().includes(paramName)) {
          this.choosenFields[i] = (paramName)
        } else if (order && order > 0) {
          this.choosenFields[i] = (order)
        } else {
          return
        }

        this.search[i] = (this.$route.query[paramName])
        i++
      }

      if (this.search.length > 0) {
        this.range = this.search.length
        this.$emit('change-condition', this.buildCondition())
        this.showFilter = true
      }
    }
  },
  created() {
    this.applyFilterFromUrl()
  }
}
</script>

<style>
.filtr-active {
  background-color: #00ab00 !important;
}
</style>
